import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Image.svg'

export const IconImage = IconSVG as IconComponent
